import { cn } from "@lib/cn";
import { useLockedAction } from "../hooks";

const PLAN_STYLES = {
  container: {
    starter: "tw-bg-starter-background tw-border-starter-base/30",
    pro: "tw-bg-pro-background tw-border-pro-base/30",
    team: "tw-bg-team-background tw-border-team-base/30",
  },
  limit: {
    starter: "tw-bg-starter-base/30",
    pro: "tw-bg-pro-base/30",
    team: "tw-bg-team-base/30",
  },
  limitBar: {
    starter: "tw-bg-starter-base",
    pro: "tw-bg-pro-base",
    team: "tw-bg-team-base",
  },
  text: {
    starter: "tw-text-starter-base",
    pro: "tw-text-pro-base",
    team: "tw-text-team-base",
  },
};

const VersionOgImageLimit = ({ count }: { count: number }) => {
  const { value: versionsLimit, plan } = useLockedAction({
    feature: "version-og-image-limit",
  });
  if (typeof versionsLimit !== "number") return null;

  return (
    <div className="tw-w-full">
      <div
        className={cn(
          "tw-flex tw-min-h-14 tw-flex-col tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-bg-starter-background tw-px-3 tw-py-2",
          PLAN_STYLES.container[plan as keyof typeof PLAN_STYLES.container],
        )}
      >
        <div className="tw-flex tw-items-center tw-justify-between">
          <span className="tw-font-sans tw-text-[11px]/normal tw-font-semibold tw-text-blue">
            Generate limit:
          </span>

          <span
            className={cn(
              "tw-font-sans tw-text-[10px]/normal tw-font-semibold tw-uppercase tw-tabular-nums",
              PLAN_STYLES.text[plan as keyof typeof PLAN_STYLES.text],
            )}
          >
            {count || 0}/{versionsLimit}
          </span>
        </div>

        <div
          className={cn(
            "tw-mt-2 tw-h-[6px] tw-w-full tw-overflow-hidden tw-rounded-lg",
            PLAN_STYLES.limit[plan as keyof typeof PLAN_STYLES.limit],
          )}
        >
          <span
            className={cn(
              "tw-block tw-h-full tw-rounded-lg tw-transition-all tw-duration-300",
              PLAN_STYLES.limitBar[plan as keyof typeof PLAN_STYLES.limitBar],
            )}
            style={{
              width: `${((count || 0) / versionsLimit) * 100}%`,
            }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default VersionOgImageLimit;
